(function () {
  document.querySelectorAll('[data-product-showcase-lola]').forEach(function (section) {
    initShowcase(section);
  });

  function initShowcase(section) {
    var details = Array.prototype.slice.call(section.querySelectorAll('[data-product-showcase-detail]'));
    var images = Array.prototype.slice.call(section.querySelectorAll('[data-product-showcase-image]'));
    var prevBtn = section.querySelector('[data-product-showcase-prev]');
    var nextBtn = section.querySelector('[data-product-showcase-next]');
    var visual = section.querySelector('.product-showcase-lola__visual');
    var starsContainer = section.querySelector('[data-product-showcase-stars]');

    var total = details.length;
    if (!total) return;

    var activeIndex = 0;

    // Night-mode decorative stars — same technique as flavors-lola's
    // spawnStars(): a handful of small sparkles at random positions,
    // re-generated (not just re-shown) on every product change. Hidden
    // entirely in day mode via CSS, so this runs regardless of theme —
    // there's simply nothing visible to regenerate when it's daytime.
    function spawnStars() {
      if (!starsContainer) return;
      starsContainer.innerHTML = '';

      var count = 14;
      for (var i = 0; i < count; i++) {
        var star = document.createElement('span');
        star.className = 'product-showcase-lola__star';
        star.textContent = '\u2726'; // ✦ four-pointed sparkle glyph

        // Ring/donut distribution instead of uniform random: an angle
        // plus a radius that's never too small, so stars land away
        // from the center (where the bottle already is) and read as
        // framing the product rather than competing with it.
        var angle = Math.random() * Math.PI * 2;
        var radiusX = 30 + Math.random() * 24; // 30-54% from center
        var radiusY = 32 + Math.random() * 26; // 32-58% from center
        var left = 50 + Math.cos(angle) * radiusX;
        var top = 50 + Math.sin(angle) * radiusY;
        left = Math.min(98, Math.max(2, left));
        top = Math.min(96, Math.max(4, top));

        star.style.setProperty('--product-showcase-lola-star-top', top.toFixed(1) + '%');
        star.style.setProperty('--product-showcase-lola-star-left', left.toFixed(1) + '%');
        star.style.setProperty('--product-showcase-lola-star-size', (Math.random() * 16.8 + 14).toFixed(1) + 'px');
        star.style.setProperty('--product-showcase-lola-star-opacity', (Math.random() * 0.45 + 0.4).toFixed(2));
        star.style.setProperty('--product-showcase-lola-star-duration', (Math.random() * 2 + 2.5).toFixed(1) + 's');
        star.style.setProperty('--product-showcase-lola-star-delay', (Math.random() * 1.2).toFixed(2) + 's');
        star.style.setProperty('--product-showcase-lola-star-drift-x', (Math.random() * 12 - 6).toFixed(1) + 'px');
        starsContainer.appendChild(star);
      }
    }

    spawnStars();

    // Rays/glow accent color: reads the "data-accent" set on each detail
    // block (from the schema's "Rays / glow accent color", per product)
    // and pushes it onto the shared CSS variable that both the sunburst
    // rays (currentColor) and the glow's background (color-mix) read
    // from. There's only one sunburst/glow element in the DOM — shared
    // across all products — so it has to be recolored via JS on every
    // switch rather than each product carrying its own copy.
    function updateAccent(index) {
      var activeDetail = details.filter(function (d) {
        return parseInt(d.getAttribute('data-index'), 10) === index;
      })[0];
      var accent = activeDetail ? activeDetail.getAttribute('data-accent') : null;
      if (accent) {
        section.style.setProperty('--product-showcase-lola-accent', accent);
      }
    }

    updateAccent(activeIndex);

    function goTo(index) {
      var nextIndex = ((index % total) + total) % total;
      if (nextIndex === activeIndex) return;

      // Fade the current pair out, then fade the new pair in shortly
      // after — a soft crossfade rather than an instant swap, matching
      // flavors-lola's own detail transition.
      details.forEach(function (detail) {
        detail.classList.remove('is-active');
      });
      images.forEach(function (image) {
        image.classList.remove('is-active');
      });

      window.setTimeout(function () {
        var nextDetail = details.filter(function (d) {
          return parseInt(d.getAttribute('data-index'), 10) === nextIndex;
        })[0];
        var nextImage = images.filter(function (img) {
          return parseInt(img.getAttribute('data-index'), 10) === nextIndex;
        })[0];

        if (nextDetail) nextDetail.classList.add('is-active');
        if (nextImage) nextImage.classList.add('is-active');
      }, 80);

      activeIndex = nextIndex;
      spawnStars();
      updateAccent(activeIndex);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
      });
    }

    // Keyboard support when the visual area has focus.
    if (visual) {
      visual.setAttribute('tabindex', '0');
      visual.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1);
        }
      });

      // Touch swipe: mouse-drag on desktop, touch-swipe on mobile, via
      // the Pointer Events API — same unified approach used elsewhere
      // in the theme's carousels.
      var isDragging = false;
      var dragStartX = 0;

      visual.addEventListener('pointerdown', function (event) {
        isDragging = true;
        dragStartX = event.clientX;
        visual.setPointerCapture(event.pointerId);
      });

      visual.addEventListener('pointerup', function (event) {
        if (!isDragging) return;
        isDragging = false;

        var delta = event.clientX - dragStartX;
        var threshold = 40;

        if (delta > threshold) {
          goTo(activeIndex - 1);
        } else if (delta < -threshold) {
          goTo(activeIndex + 1);
        }
      });

      visual.addEventListener('pointercancel', function () {
        isDragging = false;
      });
    }
  }
})();
